export function isIntegrationOutboxRequest(config) {
  return Boolean(config && config.integrationOutboxRequest)
}

export function integrationOutboxError(body, httpStatus) {
  const businessCode = body && typeof body.code === 'number' ? body.code : null
  const unauthorized = httpStatus === 401 || businessCode === 401
  const forbidden = httpStatus === 403 || businessCode === 403
  let kind = 'unknown'
  let message = '操作结果暂无法确认，请先刷新并核实通知状态，不要直接再次发送。'
  if (unauthorized || forbidden) {
    kind = 'rejected'
    message = unauthorized ? '登录身份已失效，请重新登录。' : '你没有查看或处理通知发送记录的权限，请联系管理员。'
  } else if (body && ['Outbox事件不存在', '只有DEAD事件可以人工重放',
    '分页参数非法：page必须大于等于1，pageSize范围为1至200'].indexOf(body.message) !== -1) {
    kind = 'rejected'
    message = ({
      'Outbox事件不存在': '这条通知已不存在，请刷新列表后核实。',
      '只有DEAD事件可以人工重放': '只有发送失败的通知可以重新发送，请刷新并核实当前状态。',
      '分页参数非法：page必须大于等于1，pageSize范围为1至200': '列表页码或每页条数无效，请刷新后重试。'
    })[body.message]
  } else if ([400, 404, 405, 409, 422].indexOf(httpStatus) !== -1 || businessCode === 404) {
    kind = 'rejected'
    message = '操作未被允许，请核对通知状态和筛选条件。'
  }
  // No response/config/headers, arbitrary lastError, payload or server message.
  return { kind, message, unauthorized, forbidden,
    httpStatus: typeof httpStatus === 'number' ? httpStatus : null, businessCode }
}



// WEBPACK FOOTER //
// ./src/utils/integrationOutboxRequest.js